/**
 * Generates a hexadecimal color string with alpha transparency.
 *
 * @param {string} options.hex - The base hexadecimal color. Default is an empty string.
 * @param {number} options.alpha - The alpha value for transparency, ranging from 0 to 100.
 * @throws {Error} Throws an error if the hex color format is invalid.
 * @returns {string} The hexadecimal color string with alpha transparency.
 */
const hexWithAlpha = ({ hex = '', alpha }) => {
  if (!hex) return '';

  const alphaDecimal = Math.min(1, Math.max(0, alpha / 100));

  let color = hex.replace('#', '');

  if (!/^([0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/.test(color)) {
    throw new Error('Invalid hex color format');
  }

  if (color.length === 3) {
    color = color
      .split('')
      .map((c) => c + c)
      .join('');
  }

  if (color.length === 8) {
    color = color.substr(0, 6);
  }

  const hexWithAlpha = `#${color}${Math.round(alphaDecimal * 255)
    .toString(16)
    .padStart(2, '0')}`;

  return hexWithAlpha;
};

export default hexWithAlpha;
